import { render, staticRenderFns } from "./AskQuery.vue?vue&type=template&id=3428a301&scoped=true&"
import script from "./AskQuery.vue?vue&type=script&lang=js&"
export * from "./AskQuery.vue?vue&type=script&lang=js&"
import style0 from "./AskQuery.vue?vue&type=style&index=0&id=3428a301&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3428a301",
  null
  
)

export default component.exports